var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M4 .702 4.712 0l8.865 8.994L4.71 17.88l-.708-.707L12.17 8.99z"}));
}

ArrowRight.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
